// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout-menu-container {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 5.5rem);
}

.layout-sidebar {
    position: fixed;
    width: 300px;
    height: calc(100vh - 5.5rem);
    z-index: 999;
    overflow-y: auto;
    -webkit-user-select: none;
            user-select: none;
    top: 5.9rem;
    left: 0;
    transition: transform 0.2s, left 0.2s;
    background-color: var(--bg-card);
    padding: 1.5rem;
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);
    border-right: 1px solid var(--border-color);
}

.layout-menu {
    list-style-type: none;
    margin: 0;
    padding: 0;
    flex: 1 1;
}

.layout-menu li {
    margin-bottom: 0.25rem;
}

.layout-menu li.layout-menuitem-category {
    margin-top: 1.5rem;
}

.layout-menu li.layout-menuitem-category:first-child {
    margin-top: 0;
}

.layout-menu .layout-menuitem-root-text {
    text-transform: uppercase;
    color: var(--text-secondary) !important;
    opacity: 1 !important;
    font-weight: 700;
    margin-bottom: 0.75rem;
    margin-top: 2rem;
    font-size: 0.7rem;
    letter-spacing: 0.15em;
    padding-left: 1rem;
    border-bottom: 1px solid var(--border-color);
    padding-bottom: 0.5rem;
}

.layout-menu li a {
    cursor: pointer;
    text-decoration: none;
    display: flex;
    align-items: center;
    color: var(--text-primary);
    transition: all 0.2s ease;
    border-radius: 8px;
    padding: 0.875rem 1rem;
    font-size: 0.95rem;
    font-weight: 500;
}

.layout-menu li a span {
    margin-left: 0.75rem;
}

.layout-menu li a .menuitem-toggle-icon {
    margin-left: auto;
    font-size: 0.85rem;
    transition: transform 0.3s ease;
}

.layout-menu li a i {
    color: var(--text-secondary);
    font-size: 1.1rem;
    transition: color 0.2s ease;
}

.layout-menu li a:hover {
    background-color: var(--theme-primary-soft);
    color: var(--theme-primary);
    transform: translateX(4px);
}

.layout-menu li a:hover i {
    color: var(--theme-primary);
}

.layout-menu li a.router-link-exact-active {
    background: linear-gradient(135deg, var(--theme-primary) 0%, var(--theme-primary-dark) 100%);
    color: #ffffff;
    font-weight: 600;
    box-shadow: 0 2px 8px rgba(74, 144, 226, 0.3);
}

.layout-menu li a.router-link-exact-active i {
    color: #ffffff;
}

.layout-menu li a.router-link-exact-active:hover {
    background: linear-gradient(135deg, var(--theme-primary-dark) 0%, var(--theme-primary-dark) 100%);
    transform: translateX(4px);
}

.layout-menu li.active-menuitem>a .menuitem-toggle-icon:before {
    content: '\\e933';
}

.layout-menu li ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    overflow: hidden;
}

.layout-menu li ul.layout-submenu-wrapper-enter {
    max-height: 0;
}

.layout-menu li ul.layout-submenu-wrapper-enter-active {
    overflow: hidden;
    max-height: 1000px;
    transition: max-height 1s ease-in-out;
}

.layout-menu li ul.layout-submenu-wrapper-enter-done {
    transform: none;
}

.layout-menu li ul.layout-submenu-wrapper-exit {
    max-height: 1000px;
}

.layout-menu li ul.layout-submenu-wrapper-exit-active {
    overflow: hidden;
    max-height: 0;
    transition: max-height 0.45s cubic-bezier(0.86, 0, 0.07, 1);
}

.layout-menu li ul ul {
    padding-left: 1rem;
}

.layout-menu li ul li a {
    padding-left: 2.5rem;
    font-size: 0.9rem;
}

.layout-menu .p-badge {
    margin-left: auto;
}

.layout-menu-footer {
    margin-top: auto;
    padding: 1.5rem 1rem;
    width: 100%;
    border-top: 1px solid var(--border-color);
    text-align: center;
}

.menu-footer-text {
    margin: 0;
    color: var(--text-secondary);
    font-size: 0.85rem;
    font-weight: 500;
    letter-spacing: 0.02em;
}

/* Scrollbar personalizado */
.layout-sidebar::-webkit-scrollbar {
    width: 6px;
}

.layout-sidebar::-webkit-scrollbar-track {
    background: transparent;
}

.layout-sidebar::-webkit-scrollbar-thumb {
    background: #e3eaf3;
    border-radius: 3px;
}

.layout-sidebar::-webkit-scrollbar-thumb:hover {
    background: #6c757d;
}

/* Responsive */
@media (max-width: 991px) {
    .layout-sidebar {
        width: 250px;
    }
}

@media (max-width: 768px) {
    .layout-sidebar {
        transform: translateX(-100%);
    }

    .layout-sidebar.active {
        transform: translateX(0);
    }
}`, "",{"version":3,"sources":["webpack://./src/AppMenu.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,4BAA4B;IAC5B,YAAY;IACZ,gBAAgB;IAChB,yBAAiB;YAAjB,iBAAiB;IACjB,WAAW;IACX,OAAO;IACP,qCAAqC;IACrC,gCAAgC;IAChC,eAAe;IACf,yCAAyC;IACzC,2CAA2C;AAC/C;;AAEA;IACI,qBAAqB;IACrB,SAAS;IACT,UAAU;IACV,SAAO;AACX;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,uCAAuC;IACvC,qBAAqB;IACrB,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,4CAA4C;IAC5C,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,0BAA0B;IAC1B,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,2CAA2C;IAC3C,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,4FAA4F;IAC5F,cAAc;IACd,gBAAgB;IAChB,6CAA6C;AACjD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iGAAiG;IACjG,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,SAAS;IACT,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,2DAA2D;AAC/D;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,WAAW;IACX,yCAAyC;IACzC,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,4BAA4B;IAC5B,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA,4BAA4B;AAC5B;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,eAAe;AACf;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,4BAA4B;IAChC;;IAEA;QACI,wBAAwB;IAC5B;AACJ","sourcesContent":[".layout-menu-container {\n    display: flex;\n    flex-direction: column;\n    height: calc(100vh - 5.5rem);\n}\n\n.layout-sidebar {\n    position: fixed;\n    width: 300px;\n    height: calc(100vh - 5.5rem);\n    z-index: 999;\n    overflow-y: auto;\n    user-select: none;\n    top: 5.9rem;\n    left: 0;\n    transition: transform 0.2s, left 0.2s;\n    background-color: var(--bg-card);\n    padding: 1.5rem;\n    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);\n    border-right: 1px solid var(--border-color);\n}\n\n.layout-menu {\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n    flex: 1;\n}\n\n.layout-menu li {\n    margin-bottom: 0.25rem;\n}\n\n.layout-menu li.layout-menuitem-category {\n    margin-top: 1.5rem;\n}\n\n.layout-menu li.layout-menuitem-category:first-child {\n    margin-top: 0;\n}\n\n.layout-menu .layout-menuitem-root-text {\n    text-transform: uppercase;\n    color: var(--text-secondary) !important;\n    opacity: 1 !important;\n    font-weight: 700;\n    margin-bottom: 0.75rem;\n    margin-top: 2rem;\n    font-size: 0.7rem;\n    letter-spacing: 0.15em;\n    padding-left: 1rem;\n    border-bottom: 1px solid var(--border-color);\n    padding-bottom: 0.5rem;\n}\n\n.layout-menu li a {\n    cursor: pointer;\n    text-decoration: none;\n    display: flex;\n    align-items: center;\n    color: var(--text-primary);\n    transition: all 0.2s ease;\n    border-radius: 8px;\n    padding: 0.875rem 1rem;\n    font-size: 0.95rem;\n    font-weight: 500;\n}\n\n.layout-menu li a span {\n    margin-left: 0.75rem;\n}\n\n.layout-menu li a .menuitem-toggle-icon {\n    margin-left: auto;\n    font-size: 0.85rem;\n    transition: transform 0.3s ease;\n}\n\n.layout-menu li a i {\n    color: var(--text-secondary);\n    font-size: 1.1rem;\n    transition: color 0.2s ease;\n}\n\n.layout-menu li a:hover {\n    background-color: var(--theme-primary-soft);\n    color: var(--theme-primary);\n    transform: translateX(4px);\n}\n\n.layout-menu li a:hover i {\n    color: var(--theme-primary);\n}\n\n.layout-menu li a.router-link-exact-active {\n    background: linear-gradient(135deg, var(--theme-primary) 0%, var(--theme-primary-dark) 100%);\n    color: #ffffff;\n    font-weight: 600;\n    box-shadow: 0 2px 8px rgba(74, 144, 226, 0.3);\n}\n\n.layout-menu li a.router-link-exact-active i {\n    color: #ffffff;\n}\n\n.layout-menu li a.router-link-exact-active:hover {\n    background: linear-gradient(135deg, var(--theme-primary-dark) 0%, var(--theme-primary-dark) 100%);\n    transform: translateX(4px);\n}\n\n.layout-menu li.active-menuitem>a .menuitem-toggle-icon:before {\n    content: '\\e933';\n}\n\n.layout-menu li ul {\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n    overflow: hidden;\n}\n\n.layout-menu li ul.layout-submenu-wrapper-enter {\n    max-height: 0;\n}\n\n.layout-menu li ul.layout-submenu-wrapper-enter-active {\n    overflow: hidden;\n    max-height: 1000px;\n    transition: max-height 1s ease-in-out;\n}\n\n.layout-menu li ul.layout-submenu-wrapper-enter-done {\n    transform: none;\n}\n\n.layout-menu li ul.layout-submenu-wrapper-exit {\n    max-height: 1000px;\n}\n\n.layout-menu li ul.layout-submenu-wrapper-exit-active {\n    overflow: hidden;\n    max-height: 0;\n    transition: max-height 0.45s cubic-bezier(0.86, 0, 0.07, 1);\n}\n\n.layout-menu li ul ul {\n    padding-left: 1rem;\n}\n\n.layout-menu li ul li a {\n    padding-left: 2.5rem;\n    font-size: 0.9rem;\n}\n\n.layout-menu .p-badge {\n    margin-left: auto;\n}\n\n.layout-menu-footer {\n    margin-top: auto;\n    padding: 1.5rem 1rem;\n    width: 100%;\n    border-top: 1px solid var(--border-color);\n    text-align: center;\n}\n\n.menu-footer-text {\n    margin: 0;\n    color: var(--text-secondary);\n    font-size: 0.85rem;\n    font-weight: 500;\n    letter-spacing: 0.02em;\n}\n\n/* Scrollbar personalizado */\n.layout-sidebar::-webkit-scrollbar {\n    width: 6px;\n}\n\n.layout-sidebar::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.layout-sidebar::-webkit-scrollbar-thumb {\n    background: #e3eaf3;\n    border-radius: 3px;\n}\n\n.layout-sidebar::-webkit-scrollbar-thumb:hover {\n    background: #6c757d;\n}\n\n/* Responsive */\n@media (max-width: 991px) {\n    .layout-sidebar {\n        width: 250px;\n    }\n}\n\n@media (max-width: 768px) {\n    .layout-sidebar {\n        transform: translateX(-100%);\n    }\n\n    .layout-sidebar.active {\n        transform: translateX(0);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
